import {
  Box,
  Button,
  ButtonBase,
  ButtonProps,
  CircularProgress,
  SxProps,
} from '@mui/material';
import { Link } from 'react-router-dom';
import {
  defaultButtonStyles,
  linkButtonStyles,
  loadingContainerStyles,
} from './styles';
import { MyTheme } from 'src/theme';

type DefaultButtonProps = ButtonProps & {
  isLoading?: boolean;
  to?: string;
};

export function DefaultButton({
  sx = {},
  isLoading,
  children,
  variant = 'contained',
  to,
  ...rest
}: DefaultButtonProps): React.JSX.Element {
  return to ? (
    <ButtonBase 
      sx={{ ...linkButtonStyles, ...sx } as SxProps<MyTheme>} component="div">
      <Link to={to}>{children}</Link>
    </ButtonBase>
  ) : (
    <Button
      variant={variant}
      sx={{ ...defaultButtonStyles, ...sx } as SxProps<MyTheme>}
      disabled={isLoading}
      {...rest}
    >
      {children}
      {isLoading && (
        <Box sx={loadingContainerStyles}>
          <CircularProgress size="1em" color="inherit" />
        </Box>
      )}
    </Button>
  );
}
